/**
 * Message moderation scenarios (Admin Messages).
 * Parent Message (MSG-####) contains Message Threads (MTH-####).
 * One parent Message per Customer–Business pair.
 */

const messageScenarios = [
  // Scenario 1 — Harassment / Abusive Language (Medium → Under Review)
  {
    scenarioKey: 1,
    name: 'Harassment / Abusive Language',
    conversation: {
      conversationId: 'MSG-7011',
      startedFrom: 'Post',
      startingPostTitle: 'Bathroom Renovation — Werribee',
      startingPostId: 'POST-7841',
      startedAt: '2026-01-30T10:00:00.000Z',
      lastUpdated: '2026-01-30T10:21:00.000Z',
    },
    messages: [
      { id: 'MTH-7011', sender: 'Customer', senderId: 'CUS-2187', text: 'Hi, I need a quote for a bathroom reno in Werribee.', timestamp: '2026-01-30T10:01:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T10:02:00.000Z', visibility: 'Visible', isFlagged: false, postId: 'POST-7841', postTitle: 'Bathroom Renovation — Werribee' },
      { id: 'MTH-7012', sender: 'Business', senderId: 'BUS-9934', text: 'Sure, we can help. When would you like us to come around?', timestamp: '2026-01-30T10:05:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T10:06:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7013', sender: 'Customer', senderId: 'CUS-2187', text: 'Preferably next week if you have availability — it is a full strip-out.', timestamp: '2026-01-30T10:07:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T10:08:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7014', sender: 'Business', senderId: 'BUS-9934', text: 'We can slot a site visit Wed or Thu. I will confirm after a quick scope check.', timestamp: '2026-01-30T10:09:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T10:10:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7015', sender: 'Customer', senderId: 'CUS-2187', text: 'You plumbers are all the same — incompetent and overpriced. Don’t bother.', timestamp: '2026-01-30T10:12:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T10:13:00.000Z', visibility: 'Visible', isFlagged: true },
      { id: 'MTH-7016', sender: 'Business', senderId: 'BUS-9934', text: 'We’d prefer to keep this discussion here. Happy to continue in chat.', timestamp: '2026-01-30T10:15:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T10:15:30.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7017', sender: 'Customer', senderId: 'CUS-2187', text: 'Fine. I still want the quote — just stressed about timelines.', timestamp: '2026-01-30T10:16:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T10:16:30.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7018', sender: 'Business', senderId: 'BUS-9934', text: 'Understood. Let’s reset — tell me rough room size and whether you need waterproofing redone.', timestamp: '2026-01-30T10:17:30.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T10:18:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7019', sender: 'Customer', senderId: 'CUS-2187', text: 'About 6 m² floor, yes full waterproofing. Single vanity, walk-in shower.', timestamp: '2026-01-30T10:19:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T10:19:30.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7020', sender: 'Business', senderId: 'BUS-9934', text: 'Thanks — I will price membrane + screed and send an itemised estimate within 48 hours.', timestamp: '2026-01-30T10:21:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T10:21:30.000Z', visibility: 'Visible', isFlagged: false },
    ],
    customer: { customerId: 'CUS-2187', name: 'Sarah Kerr', memberSince: '2024-03-15', lastActive: '2026-01-30T10:15:00.000Z', accountStatus: 'Active', blockStatus: 'Not blocked' },
    business: { businessId: 'BUS-9934', businessName: 'Werribee Plumbing Pty Ltd', category: 'Plumbing', verificationStatus: 'Verified', accountStatus: 'Active', blockStatus: 'Not blocked', memberSince: '2022-08-01' },
    flag: {
      flagId: 'FLG-50101',
      source: 'Business Flag',
      flaggedBy: 'Werribee Plumbing Pty Ltd',
      messageThreadId: 'MTH-7015',
      category: 'Moderation',
      trigger: 'Harassment / abusive language in messages',
      reason: 'Harassment / abusive language in messages',
      severity: 'Medium',
      status: 'Active',
      linkedCaseId: 'MOD-000701',
      createdAt: '2026-01-30T10:20:00.000Z',
      updatedAt: '2026-01-30T10:20:00.000Z',
    },
    case: {
      caseId: 'MOD-000701',
      contentType: 'Message',
      severity: 'Medium',
      status: 'Active',
      assignedTo: 'Alex Chen',
      created: '2026-01-30T10:20:00.000Z',
      updated: '2026-01-30T10:20:00.000Z',
    },
    messagingState: 'Active',
    adminNote: 'Customer sent insults after initial enquiry. Business reported. Consider warning and messaging restriction.',
  },

  // Scenario 2 — Scam / Fraud Attempt (High → Under Review)
  {
    scenarioKey: 2,
    name: 'Scam / Fraud Attempt',
    conversation: {
      conversationId: 'MSG-7018',
      startedFrom: 'Post',
      startingPostTitle: 'Emergency Drain Clearing Available',
      startingPostId: 'POST-7856',
      startedAt: '2026-01-30T22:00:00.000Z',
      lastUpdated: '2026-01-30T22:19:30.000Z',
    },
    messages: [
      { id: 'MTH-7101', sender: 'Customer', senderId: 'CUS-3349', text: 'Interested in your plumbing services. Can you send me a quote?', timestamp: '2026-01-30T22:02:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T22:03:00.000Z', visibility: 'Visible', isFlagged: false, postId: 'POST-7856', postTitle: 'Blocked Drain Service Available' },
      { id: 'MTH-7102', sender: 'Business', senderId: 'BUS-4412', text: 'Sure. I can review the details and get back to you shortly.', timestamp: '2026-01-30T22:08:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T22:08:30.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7103', sender: 'Business', senderId: 'BUS-4412', text: 'Let me know the preferred time window for the job and I’ll confirm availability.', timestamp: '2026-01-30T22:09:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T22:09:20.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7104', sender: 'Customer', senderId: 'CUS-3349', text: 'Thanks. Please send through your availability for next week.', timestamp: '2026-01-30T22:09:30.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T22:10:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7105', sender: 'Business', senderId: 'BUS-4412', text: 'Tuesday AM or Thursday PM works on our side. Which suburb is the job in?', timestamp: '2026-01-30T22:10:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T22:10:20.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7106', sender: 'Customer', senderId: 'CUS-3349', text: 'Brunswick — terraced house, rear lane access only.', timestamp: '2026-01-30T22:10:45.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T22:11:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7107', sender: 'Business', senderId: 'BUS-4412', text: 'Noted. I will bring a compact jet kit for the lane. Photos of the existing pipework help if you have them.', timestamp: '2026-01-30T22:11:30.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T22:12:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7108', sender: 'Customer', senderId: 'CUS-3349', text: 'Will upload two pics of under the sink tonight.', timestamp: '2026-01-30T22:12:15.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T22:12:45.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7109', sender: 'Business', senderId: 'BUS-4412', text: 'Perfect — once I see those I will lock Tuesday vs Thursday and send the formal quote.', timestamp: '2026-01-30T22:13:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T22:14:00.000Z', visibility: 'Visible', isFlagged: true },
      { id: 'MTH-7110', sender: 'Customer', senderId: 'CUS-3349', text: 'Sent — let me know if you need anything else before you quote.', timestamp: '2026-01-30T22:18:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T22:18:30.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7111', sender: 'Business', senderId: 'BUS-4412', text: 'Received. One line looks corroded — I will include replacement options in the estimate.', fileName: null, timestamp: '2026-01-30T22:19:30.000Z', direction: 'Business → Customer', messageStatus: 'Delivered', visibility: 'Visible', isFlagged: false },
    ],
    customer: { customerId: 'CUS-3349', name: 'Daniel Morris', memberSince: '2023-08-01', lastActive: '2026-01-30T11:10:00.000Z', accountStatus: 'Active', blockStatus: 'Not blocked' },
    business: { businessId: 'BUS-4412', businessName: 'RapidFix Plumbing Pty Ltd', category: 'Plumbing', verificationStatus: 'Verified', accountStatus: 'Active', blockStatus: 'Not blocked', memberSince: '2023-05-12' },
    flag: {
      flagId: 'FLG-50102',
      source: 'Customer Flag',
      flaggedBy: 'Daniel Morris',
      messageThreadId: 'MTH-7109',
      category: 'Moderation',
      trigger: 'Attempt to move messaging off-platform or request payment outside platform flow',
      reason: 'Attempt to move messaging off-platform or request payment outside platform flow',
      severity: 'High',
      status: 'Active',
      linkedCaseId: 'MOD-000702',
      createdAt: '2026-01-30T11:15:00.000Z',
      updatedAt: '2026-01-30T11:15:00.000Z',
    },
    case: {
      caseId: 'MOD-000702',
      contentType: 'Message',
      severity: 'High',
      status: 'New',
      assignedTo: 'Unassigned',
      created: '2026-01-30T11:15:00.000Z',
      updated: '2026-01-30T11:15:00.000Z',
    },
    messagingState: 'Active',
    adminNote: 'Business requested direct payment and contact off-platform. Escalation to Fraud & Security recommended.',
  },

  // Scenario 3 — Low Flag with linked Decided case → parent stays Active
  {
    scenarioKey: 3,
    name: 'No Violation / Legitimate Dispute',
    conversation: {
      conversationId: 'MSG-7025',
      startedFrom: 'Business Profile',
      startingPostTitle: null,
      startingPostId: null,
      startedAt: '2026-01-30T20:00:00.000Z',
      lastUpdated: '2026-01-30T20:54:00.000Z',
    },
    messages: [
      { id: 'MTH-7201', sender: 'Customer', senderId: 'CUS-2874', text: 'Quote received thanks. The price is higher than another tradie — can you match $X?', timestamp: '2026-01-30T20:30:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T20:31:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7202', sender: 'Business', senderId: 'BUS-5091', text: 'We can’t reduce our rate for that scope. Our quote includes warranty and quality materials.', timestamp: '2026-01-30T20:45:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T20:46:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7203', sender: 'Customer', senderId: 'CUS-2874', text: 'Fair enough — can you itemise labour vs materials so I can compare apples to apples?', timestamp: '2026-01-30T20:46:30.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T20:47:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7204', sender: 'Business', senderId: 'BUS-5091', text: 'Already in the PDF — see page 2 breakdown. Happy to walk through on a quick call.', timestamp: '2026-01-30T20:47:45.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T20:48:00.000Z', visibility: 'Visible', isFlagged: true },
      { id: 'MTH-7205', sender: 'Customer', senderId: 'CUS-2874', text: 'Understood. I’ll go with the other option then. Thanks.', timestamp: '2026-01-30T20:50:00.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T20:50:30.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7206', sender: 'Business', senderId: 'BUS-5091', text: 'No worries. Feel free to come back if things change.', timestamp: '2026-01-30T20:52:00.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T20:52:20.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7207', sender: 'Customer', senderId: 'CUS-2874', text: 'Will do — appreciate the quick replies.', timestamp: '2026-01-30T20:52:45.000Z', direction: 'Customer → Business', messageStatus: 'Read', readOn: '2026-01-30T20:53:00.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7208', sender: 'Business', senderId: 'BUS-5091', text: 'Anytime. Good luck with the project.', timestamp: '2026-01-30T20:53:30.000Z', direction: 'Business → Customer', messageStatus: 'Read', readOn: '2026-01-30T20:53:45.000Z', visibility: 'Visible', isFlagged: false },
      { id: 'MTH-7209', sender: 'Customer', senderId: 'CUS-2874', text: 'Cheers.', fileName: null, timestamp: '2026-01-30T20:54:00.000Z', direction: 'Customer → Business', messageStatus: 'Delivered', visibility: 'Visible', isFlagged: false },
    ],
    customer: { customerId: 'CUS-2874', name: 'Emily Rogers', memberSince: '2024-01-10', lastActive: '2026-01-30T09:52:00.000Z', accountStatus: 'Active', blockStatus: 'Not blocked' },
    business: { businessId: 'BUS-5091', businessName: 'UrbanFix Plumbing', category: 'Plumbing', verificationStatus: 'Verified', accountStatus: 'Active', blockStatus: 'Not blocked', memberSince: '2022-11-20' },
    flag: {
      flagId: 'FLG-50103',
      source: 'Business Flag',
      flaggedBy: 'UrbanFix Plumbing',
      messageThreadId: 'MTH-7204',
      category: 'Moderation',
      trigger: 'Reported out of frustration — price negotiation / scheduling',
      reason: 'Reported out of frustration — price negotiation / scheduling',
      severity: 'Low',
      status: 'Decided',
      linkedCaseId: 'MOD-000703',
      createdAt: '2026-01-30T10:00:00.000Z',
      updatedAt: '2026-01-30T10:00:00.000Z',
    },
    // Every accepted Flag has one linked case, including Low. Low alone does not pause sending.
    case: {
      caseId: 'MOD-000703',
      contentType: 'Message',
      severity: 'Low',
      status: 'Decided',
      assignedTo: 'Alex Chen',
      created: '2026-01-30T10:00:00.000Z',
      updated: '2026-01-30T10:05:00.000Z',
      outcome: 'No Violation',
      closedBy: 'Alex Chen',
      closedDate: '2026-01-30T10:05:00.000Z',
    },
    messagingState: 'Active',
    adminNote: 'Heated but professional price discussion. No abuse or scam. Low flag recorded with Decided case.',
  },
];

export function getMessageScenarioByCaseId(caseId) {
  if (!caseId) return null;
  const n = String(caseId).replace(/^(?:MODS|MOA|MOD)-?/i, '');
  return (
    messageScenarios.find(
      (s) => s.case && String(s.case.caseId).replace(/^(?:MODS|MOA|MOD)-?/i, '') === n
    ) || null
  );
}

export function getMessageScenarioByConversationId(conversationId) {
  if (!conversationId) return null;
  const n = String(conversationId).replace(/^MSG-?/i, '').replace(/^CONV-?/i, '');
  return messageScenarios.find((s) => {
    const sid = String(s.conversation.conversationId).replace(/^MSG-?/i, '').replace(/^CONV-?/i, '');
    return sid === n;
  }) || null;
}

/** Moderation Queue — excludes closed-flag / no-violation dispute thread. */
const MESSAGE_QUEUE_EXCLUDED_SCENARIO_KEYS = [3];

function resolveMessageCaseSource(flag, scenarioKey) {
  const source = String(flag?.source || '').toLowerCase();
  if (source.includes('detection')) return 'Detection';
  if (source === 'system' || source.includes('system')) return 'System Signal';
  // Demo System Signal sample (abusive-language signal) — no user Flag count
  if (scenarioKey === 1) return 'System Signal';
  return 'User Flag';
}

export function getMessageQueueCases() {
  return messageScenarios
    .filter((s) => !MESSAGE_QUEUE_EXCLUDED_SCENARIO_KEYS.includes(s.scenarioKey) && s.case)
    .map((s) => {
    const c = s.case;
    const f = s.flag;
    const preview = 'Message Thread';
    const status = c.status || 'New';
    const reviewReason = f.reason || f.trigger || '—';
    const caseSource = resolveMessageCaseSource(f, s.scenarioKey);
    const flagCount = caseSource === 'User Flag' ? 1 : null;
    return {
      caseId: c.caseId,
      contentType: 'Message',
      preview,
      caseSource,
      reviewReason,
      flagReason: reviewReason,
      flagCount,
      priority: c.severity,
      severity: c.severity,
      status,
      assignedTo: c.assignedTo || 'Unassigned',
      created: c.created,
      updated: c.updated,
      conversationId: s.conversation.conversationId,
      customerId: s.customer.customerId,
      customerName: s.customer.name,
      businessId: s.business.businessId,
      businessName: s.business.businessName,
      accountName: s.business.businessName,
      accountAvatar: 'https://i.pravatar.cc/150?img=32',
      flagId: f.flagId,
    };
  });
}

/**
 * Operational Status priority:
 * Under Review (Medium/High case New or Active) → Blocked → Restricted → Active.
 * Low cases alone do not change the parent to Under Review.
 */
function deriveMessageRecordStatus(scenario) {
  const caseStatus = scenario.case?.status;
  const severity = scenario.case?.severity;
  const messagingState = scenario.messagingState || 'Active';
  const openCase =
    caseStatus === 'Under Review' ||
    caseStatus === 'In Review' ||
    caseStatus === 'New' ||
    caseStatus === 'Active';

  if (scenario.case && openCase && (severity === 'Medium' || severity === 'High')) {
    return 'Under Review';
  }
  if (messagingState === 'Blocked') return 'Blocked';
  if (messagingState === 'Restricted') return 'Restricted';
  return 'Active';
}

function latestMessagePreview(lastMsg) {
  if (!lastMsg) return '—';
  if (lastMsg.fileName) return lastMsg.fileName;
  const rawPreview = (lastMsg.text || '').trim();
  if (!rawPreview) return '—';
  return rawPreview.length > 120 ? `${rawPreview.slice(0, 120)}…` : rawPreview;
}

/** Messages list: one row per parent Message (no quotes). */
export function getMessagesForScenarios() {
  return messageScenarios.map((s) => {
    const c = s.case;
    const f = s.flag;
    const conv = s.conversation;
    const lastMsg = s.messages[s.messages.length - 1];
    const firstMsg = s.messages[0];
    const preview = latestMessagePreview(lastMsg);
    const recordStatus = deriveMessageRecordStatus(s);
    const caseStatus = c?.status || null;
    const startedFromType = conv.startedFrom === 'Post' ? 'Post' : 'Business Profile';
    const startedFromDisplay =
      startedFromType === 'Post' ? (conv.startingPostTitle || 'Post') : 'Business Profile';
    const messageThreadIds = s.messages.map((m) => m.id);
    const linkedCaseId = f?.linkedCaseId || c?.caseId || null;
    const flagsList = f
      ? [{
          flagId: f.flagId,
          source: f.source,
          flaggedBy: f.flaggedBy,
          messageThreadId: f.messageThreadId,
          category: f.category,
          trigger: f.trigger,
          reason: f.reason || f.trigger,
          severity: f.severity,
          status: f.status,
          handlingStatus: f.status || c?.status || null,
          linkedCaseId,
          linkedCaseType: linkedCaseId ? 'Moderation' : null,
          createdAt: f.createdAt,
          updatedAt: f.updatedAt,
        }]
      : [];

    return {
      id: conv.conversationId,
      messageId: conv.conversationId,
      threadId: conv.conversationId,
      conversationId: conv.conversationId,
      customer: { name: s.customer.name, id: s.customer.customerId, avatar: 'https://i.pravatar.cc/150?img=32' },
      business: { name: s.business.businessName, id: s.business.businessId, avatar: 'https://i.pravatar.cc/150?img=65' },
      type: 'Message',
      latestMessagePreview: preview,
      latestMessageStatus: lastMsg?.messageStatus || 'Sent',
      latestDirection: lastMsg?.direction || (firstMsg?.sender === 'Customer' ? 'Customer → Business' : 'Business → Customer'),
      startedFromType,
      startedFrom: startedFromDisplay,
      startingPostTitle: conv.startingPostTitle || null,
      startingPostId: conv.startingPostId || null,
      totalMessageThreads: s.messages.length,
      flagsCount: flagsList.length,
      messageThreadIds,
      status: recordStatus,
      messagingState: s.messagingState || 'Active',
      flagged: flagsList.length > 0,
      underReview: recordStatus === 'Under Review',
      flagStatus: flagsList.length ? 'Has Flags' : 'None',
      quoteStatus: 'No Quote',
      quoteId: null,
      groupQuoteId: null,
      unreadCount: 0,
      created: conv.startedAt,
      lastActivity: lastMsg?.timestamp || conv.startedAt,
      lastMessageOn: lastMsg?.timestamp || conv.startedAt,
      lastUpdated: conv.lastUpdated || lastMsg?.timestamp || conv.startedAt,
      region: 'VIC',
      tradeCategory: s.business.category || 'Plumbing',
      messageCount: s.messages.length,
      conversationStartedBy: firstMsg?.sender === 'Customer' ? 'Customer' : 'Business',
      moderationCaseId: c?.caseId || null,
      flags: flagsList,
      moderationCases: c
        ? [{ caseId: c.caseId, status: caseStatus, severity: c.severity, assignedTo: c.assignedTo, created: c.created, updated: c.updated }]
        : [],
      caseStatus,
      caseSeverity: c?.severity || null,
      messages: s.messages,
    };
  });
}

export default messageScenarios;
